var map = {
	"./ADA.png": "263f",
	"./AVAX.png": "4e9e",
	"./BNB.png": "cb21",
	"./BTC.png": "5668",
	"./BUSD.png": "af16",
	"./CRD.png": "af1a",
	"./DOGE.png": "fa7d",
	"./DOT.png": "702c",
	"./ETH.png": "90b3",
	"./HBX.png": "f282",
	"./LUNA.png": "12c2",
	"./SOL.png": "ec06",
	"./THB.png": "aa47",
	"./TUSD.png": "7876",
	"./USDT.png": "bd48",
	"./VOLTZ.png": "5ab7",
	"./XRP.png": "24c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e062";